(() => {
  if (customElements.get('age-checkout')) return;

  customElements.define('age-checkout', class AgeCheckout extends HTMLElement {
    connectedCallback() {
      this.dialog = this.querySelector('.age-checkout__dialog');
      this.form = this.querySelector('[data-age-form]');
      this.error = this.querySelector('[data-age-error]');
      this.quickError = this.querySelector('[data-age-quick-error]');
      this.submitButton = this.querySelector('[data-age-submit]');
      this.yesButton = this.querySelector('[data-age-yes]');
      this.pending = null;
      this.lastFocus = null;
      this.closeTimer = null;

      document.addEventListener('keydown', (event) => this.handleKeydown(event));
      this.querySelectorAll('[data-age-close]').forEach((button) => button.addEventListener('click', () => this.close()));
      this.form.addEventListener('submit', (event) => this.verify(event));
      this.yesButton.addEventListener('click', () => this.completeVerification(this.yesButton));
      this.querySelector('[data-age-no]').addEventListener('click', () => this.rejectQuickVerification());
      [...this.form.elements].filter((element) => element.matches?.('input')).forEach((input) => {
        input.addEventListener('input', (event) => this.advanceBirthField(event));
        input.addEventListener('keydown', (event) => this.returnToPreviousBirthField(event));
      });
      this.syncRememberedVerification();
      this.openDailyGate();
    }

    cookie(name) {
      const prefix = `${name}=`;
      const match = document.cookie.split('; ').find((cookie) => cookie.startsWith(prefix));
      return match ? decodeURIComponent(match.slice(prefix.length)) : '';
    }

    isVerified() {
      if (this.dataset.customerVerified === 'true') return true;
      return this.cookie('deliquide_age_verified') === '1';
    }

    openDailyGate() {
      if (this.cookie('deliquide_age_gate') === '1') return;
      window.setTimeout(() => this.open(null, 'entry'), 120);
    }

    async syncRememberedVerification() {
      if (this.dataset.customerVerified === 'true' || !this.isVerified() || sessionStorage.getItem('deliquide_age_cart_synced') === '1') return;
      const verifiedAt = this.cookie('deliquide_age_verified_at') || new Date().toISOString();
      try {
        const response = await fetch(this.dataset.cartUpdateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { age_verified: 'true', age_verified_at: verifiedAt } })
        });
        if (response.ok) sessionStorage.setItem('deliquide_age_cart_synced', '1');
      } catch (error) {
        // The checkout interceptor remains available if synchronization fails.
      }
    }

    open(trigger, mode = 'checkout') {
      clearTimeout(this.closeTimer);
      this.lastFocus = trigger;
      this.mode = mode;
      this.dataset.mode = mode;
      const quickEntry = mode === 'entry' && window.matchMedia('(max-width: 749px)').matches;
      this.dataset.variant = quickEntry ? 'quick' : 'date';
      const eyebrow = this.querySelector('[data-age-eyebrow]');
      if (eyebrow) eyebrow.textContent = mode === 'entry' ? 'Bienvenue chez Deliquide' : 'Avant le paiement';
      const title = this.querySelector('[data-age-title]');
      if (title) title.textContent = quickEntry ? 'Avez-vous 18 ans ou plus ?' : 'Vérification d’âge';
      const description = this.querySelector('[data-age-description]');
      if (description) {
        description.textContent = quickEntry
          ? 'La vente de produits de vapotage est interdite aux mineurs. En cliquant sur « Oui », vous confirmez avoir 18 ans ou plus.'
          : 'La vente de produits de vapotage est interdite aux mineurs. Indiquez votre date de naissance pour continuer.';
      }
      this.hidden = false;
      document.body.classList.add('age-checkout-open');
      document.body.classList.toggle('age-checkout-entry-open', mode === 'entry');
      this.resetError();
      requestAnimationFrame(() => this.classList.add('is-open'));
      this.dialog.focus();
      if (!quickEntry) window.setTimeout(() => this.form.elements.day?.focus(), 220);
    }

    close() {
      if (this.mode === 'entry') return;
      this.classList.remove('is-open');
      document.body.classList.remove('age-checkout-open');
      document.body.classList.remove('age-checkout-entry-open');
      this.pending = null;
      this.closeTimer = window.setTimeout(() => {
        this.hidden = true;
        this.lastFocus?.focus();
      }, 200);
    }

    resetError() {
      this.error.hidden = true;
      this.error.textContent = '';
      this.quickError.hidden = true;
    }

    showError(message) {
      this.error.textContent = message;
      this.error.hidden = false;
    }

    rejectQuickVerification() {
      this.quickError.textContent = 'L’accès au site est réservé aux personnes âgées de 18 ans ou plus.';
      this.quickError.hidden = false;
    }

    advanceBirthField(event) {
      const input = event.currentTarget;
      const lengths = { day: 2, month: 2, year: 4 };
      const maxLength = lengths[input.name];
      if (!maxLength) return;
      const digits = input.value.replace(/\D/g, '').slice(0, maxLength);
      if (input.value !== digits) input.value = digits;
      if (digits.length < maxLength) return;
      const nextName = input.name === 'day' ? 'month' : input.name === 'month' ? 'year' : null;
      if (nextName) {
        this.form.elements[nextName].focus();
        this.form.elements[nextName].select();
      }
    }

    returnToPreviousBirthField(event) {
      if (event.key !== 'Backspace' || event.currentTarget.value) return;
      const previousName = event.currentTarget.name === 'year' ? 'month' : event.currentTarget.name === 'month' ? 'day' : null;
      if (previousName) this.form.elements[previousName].focus();
    }

    getBirthDate() {
      const day = Number(this.form.elements.day.value);
      const month = Number(this.form.elements.month.value);
      const year = Number(this.form.elements.year.value);
      if (!Number.isInteger(day) || !Number.isInteger(month) || !Number.isInteger(year)) return null;
      const date = new Date(Date.UTC(year, month - 1, day));
      if (date.getUTCFullYear() !== year || date.getUTCMonth() !== month - 1 || date.getUTCDate() !== day) return null;
      return date;
    }

    isAdult(birthDate) {
      const today = new Date();
      const eighteenthBirthday = new Date(Date.UTC(
        birthDate.getUTCFullYear() + 18,
        birthDate.getUTCMonth(),
        birthDate.getUTCDate()
      ));
      const currentDate = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
      return currentDate >= eighteenthBirthday.getTime();
    }

    async verify(event) {
      event.preventDefault();
      this.resetError();
      const birthDate = this.getBirthDate();
      if (!birthDate) {
        this.showError('Saisissez une date de naissance valide.');
        return;
      }
      if (!this.isAdult(birthDate)) {
        this.showError('Vous devez avoir au moins 18 ans pour commander ces produits.');
        return;
      }

      await this.completeVerification(this.submitButton);
    }

    async completeVerification(button) {
      this.resetError();
      button.setAttribute('aria-busy', 'true');
      const originalLabel = button.textContent;
      button.textContent = 'Vérification…';
      const verifiedAt = new Date().toISOString();

      try {
        const response = await fetch(this.dataset.cartUpdateUrl, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ attributes: { age_verified: 'true', age_verified_at: verifiedAt } })
        });
        const cart = await response.json();
        if (!response.ok || cart.status) throw new Error(cart.description || 'Enregistrement impossible');

        document.cookie = 'deliquide_age_verified=1; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
        document.cookie = `deliquide_age_verified_at=${encodeURIComponent(verifiedAt)}; Max-Age=31536000; Path=/; SameSite=Lax; Secure`;
        document.cookie = 'deliquide_age_gate=1; Max-Age=86400; Path=/; SameSite=Lax; Secure';
        sessionStorage.setItem('deliquide_age_cart_synced', '1');
        document.dispatchEvent(new CustomEvent('cart:update', { detail: { resource: cart, sourceId: 'age-checkout' } }));
        this.classList.remove('is-open');
        document.body.classList.remove('age-checkout-open');
        document.body.classList.remove('age-checkout-entry-open');
        this.hidden = true;
        this.pending = null;

      } catch (error) {
        this.showError('La vérification n’a pas pu être enregistrée. Réessayez.');
      } finally {
        button.removeAttribute('aria-busy');
        button.textContent = originalLabel;
      }
    }

    handleKeydown(event) {
      if (this.hidden) return;
      if (event.key === 'Escape') {
        event.preventDefault();
        if (this.mode !== 'entry') this.close();
        return;
      }
      if (event.key !== 'Tab') return;
      const focusable = [...this.querySelectorAll('button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')].filter((element) => element.offsetParent !== null);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  });
})();
